import React, { createContext, useContext, useState } from 'react';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [studiesData, setStudiesData] = useState({
    pending: [
      {
        id: 1,
        title: 'Mobile Gaming Behaviour – Android',
        type: 'Focus group · Delhi / Mumbai',
        researcher: 'Insight Loop Research',
        submitted: '18h ago',
        incentive: '₹5000 · 90 min',
        seats: 12,
        check: { label: 'Needs check', color: '#6A4A00', bg: '#FFF9E6' }
      },
      {
        id: 2,
        title: "Mothers' Chocolate Perception",
        type: 'Diary + focus group · Delhi',
        researcher: 'Brandwise Consumer Labs',
        submitted: '14h ago',
        incentive: '₹1000 · 150 min',
        seats: 8,
        check: { label: 'Low risk', color: '#007A21', bg: '#DCFFE5' }
      },
      {
        id: 3,
        title: 'Online Education – Male Students',
        type: 'Online interview',
        researcher: 'Freelance – Priya M.',
        submitted: '9h ago',
        incentive: '[₹] · 60 min',
        seats: 20,
        check: { label: 'Missing incentive', color: '#B3261E', bg: '#FFF0EF' }
      },
      {
        id: 4,
        title: 'Smartphone Usage – Blue-Collar',
        type: 'Focus group · Thailand',
        researcher: 'Northstar Qual',
        submitted: '6h ago',
        incentive: '฿1500 · 60 min',
        seats: 10,
        check: { label: 'Outside India', color: '#6A4A00', bg: '#FFF9E6' }
      },
      {
        id: 5,
        title: 'MDR Audio Devices',
        type: 'Home visit · Delhi',
        researcher: 'Delhi Market Pulse',
        submitted: '3h ago',
        incentive: '₹1500 · 90 min',
        seats: 10,
        check: { label: 'Low risk', color: '#007A21', bg: '#DCFFE5' }
      },
      {
        id: 6,
        title: 'HR & IT Manager Opinions',
        type: 'Online focus group',
        researcher: 'Insight Loop Research',
        submitted: '1h ago',
        incentive: '₹1000 · 90 min',
        seats: 6,
        check: { label: 'Low risk', color: '#007A21', bg: '#DCFFE5' }
      },
      {
        id: 7,
        title: 'Footwear – In-Store Buyers',
        type: 'CLT · Gurugram',
        researcher: 'Brandwise Consumer Labs',
        submitted: '20m ago',
        incentive: '₹600 · 120 min',
        seats: 24,
        check: { label: 'Low risk', color: '#007A21', bg: '#DCFFE5' }
      }
    ],
    changes: [
      {
        id: 8,
        title: 'Fintech App Onboarding Experience',
        type: 'Usability testing · Remote',
        researcher: 'Apex UX Studio',
        submitted: '1d ago',
        incentive: '₹1200 · 45 min',
        seats: 15,
        check: { label: 'Changes sent', color: '#B45309', bg: '#FEF3C7' }
      },
      {
        id: 9,
        title: 'Electric Two-Wheeler Owners Survey',
        type: 'Survey · Bengaluru',
        researcher: 'AutoInsights Corp',
        submitted: '2d ago',
        incentive: '₹800 · 30 min',
        seats: 50,
        check: { label: 'Screener revised', color: '#B45309', bg: '#FEF3C7' }
      },
      {
        id: 10,
        title: 'Grocery Delivery Subscription Study',
        type: '1-on-1 interview · Mumbai',
        researcher: 'Retail Pulse India',
        submitted: '2d ago',
        incentive: '₹1500 · 60 min',
        seats: 10,
        check: { label: 'Awaiting update', color: '#6A4A00', bg: '#FFF9E6' }
      }
    ],
    approved: [
      {
        id: 11,
        title: 'Smart Home Automation Audio Study',
        type: 'Home visit · Bengaluru',
        researcher: 'SoundWave Labs',
        submitted: 'Sep 27',
        incentive: '₹2500 · 90 min',
        seats: 14,
        check: { label: 'Live', color: '#007A21', bg: '#DCFFE5' }
      },
      {
        id: 12,
        title: 'Gen Z Beverage Preference Taste Test',
        type: 'Central Location Test · Delhi',
        researcher: 'Beverage Insights',
        submitted: 'Sep 26',
        incentive: '₹1000 · 60 min',
        seats: 40,
        check: { label: 'Live', color: '#007A21', bg: '#DCFFE5' }
      }
    ],
    rejected: [
      {
        id: 13,
        title: 'Crypto Investment Behavioral Patterns',
        type: 'Survey',
        researcher: 'BlockTrend Analytics',
        submitted: 'Sep 25',
        incentive: '₹2000 · 30 min',
        seats: 100,
        check: { label: 'Violates policy', color: '#B3261E', bg: '#FFF0EF' }
      },
      {
        id: 14,
        title: 'Personal Loan Applicant Interview',
        type: 'Phone call',
        researcher: 'LendFast Research',
        submitted: 'Sep 24',
        incentive: '₹500 · 20 min',
        seats: 25,
        check: { label: 'PII requested', color: '#B3261E', bg: '#FFF0EF' }
      }
    ]
  });

  const [verificationItems, setVerificationItems] = useState([
    {
      id: 1,
      participant: 'Aman Sharma',
      study: 'Mobile Gaming Behaviour',
      document: 'Gaming screenshot',
      uploaded: '12m ago',
      result: { label: 'Match', color: '#007A21', bg: '#DCFFE5' },
      isFlagged: false
    },
    {
      id: 2,
      participant: 'Neha Verma',
      study: 'Footwear – In-Store',
      document: 'Product photo',
      uploaded: '25m ago',
      result: { label: 'Match', color: '#007A21', bg: '#DCFFE5' },
      isFlagged: false
    },
    {
      id: 3,
      participant: 'Rohit Jain',
      study: 'Footwear – In-Store',
      document: 'Product photo',
      uploaded: '41m ago',
      result: { label: 'Possible edit', color: '#B3261E', bg: '#FFF0EF' },
      isFlagged: true
    },
    {
      id: 4,
      participant: 'Meera Iyer',
      study: 'MDR Audio Devices',
      document: 'Selfie with product',
      uploaded: '1h ago',
      result: { label: 'Blurry', color: '#6A4A00', bg: '#FFF9E6' },
      isFlagged: true
    },
    {
      id: 5,
      participant: 'Arjun Das',
      study: 'HR & IT Managers',
      document: 'Visiting card',
      uploaded: '1h ago',
      result: { label: 'Name mismatch', color: '#B3261E', bg: '#FFF0EF' },
      isFlagged: true
    },
    {
      id: 6,
      participant: 'Tanya Arora',
      study: 'Smartphone Purchase',
      document: 'Bill + settings screenshot',
      uploaded: '2h ago',
      result: { label: 'Match', color: '#007A21', bg: '#DCFFE5' },
      isFlagged: false
    }
  ]);

  const [failedPayouts, setFailedPayouts] = useState([
    {
      id: 1,
      participant: 'Rohit Verma',
      upi: 'rohit.v@okhdfc',
      error: 'UPI inactive',
      amount: '₹1,500'
    },
    {
      id: 2,
      participant: 'Ananya Iyer',
      upi: 'ananya@ybl',
      error: 'Name mismatch',
      amount: '₹2,000'
    },
    {
      id: 3,
      participant: 'Kavita Sundaram',
      upi: 'ksundaram@icici',
      error: 'Bank down',
      amount: '₹5,000'
    }
  ]);

  const [tickets, setTickets] = useState([
    {
      id: '#4821',
      from: 'Aman Sharma',
      fromRole: 'Participant',
      subject: 'Payout not received for Gaming study',
      priority: { label: 'High', color: '#B3261E', bg: '#FFF0EF' },
      sla: 'Past SLA',
      status: { label: 'Open', color: '#0060D4', bg: '#ECF4FF' },
      isOpen: true,
      isPastSla: true
    },
    {
      id: '#4819',
      from: 'Insight Loop Research',
      fromRole: 'Researcher',
      subject: 'Need GST invoice with new company name',
      priority: { label: 'Normal', color: '#60606B', bg: '#F2F2F2' },
      sla: '6h left',
      status: { label: 'Open', color: '#0060D4', bg: '#ECF4FF' },
      isOpen: true,
      isPastSla: false
    },
    {
      id: '#4816',
      from: 'Pooja Rawat',
      fromRole: 'Participant',
      subject: 'Can I bring my child to the tasting?',
      priority: { label: 'Low', color: '#60606B', bg: '#F2F2F2' },
      sla: '1d left',
      status: { label: 'Waiting on user', color: '#6A4A00', bg: '#FFF9E6' },
      isOpen: false,
      isPastSla: false
    },
    {
      id: '#4812',
      from: 'Northstar Qual',
      fromRole: 'Researcher',
      subject: 'KYC document keeps getting rejected',
      priority: { label: 'High', color: '#B3261E', bg: '#FFF0EF' },
      sla: 'Past SLA',
      status: { label: 'Open', color: '#0060D4', bg: '#ECF4FF' },
      isOpen: true,
      isPastSla: true
    },
    {
      id: '#4807',
      from: 'Riya Kapoor',
      fromRole: 'Participant',
      subject: 'Change UPI ID',
      priority: { label: 'Normal', color: '#60606B', bg: '#F2F2F2' },
      sla: '—',
      status: { label: 'Resolved', color: '#007A21', bg: '#DCFFE5' },
      isOpen: false,
      isPastSla: false
    }
  ]);

  const [safetyCases, setSafetyCases] = useState([
    {
      id: 'FR-112',
      signal: 'Same device on 3 accounts',
      accounts: 'Rohit Jain + 2',
      severity: { label: 'High', color: '#B3261E', bg: '#FFF0EF' },
      raised: '2h ago',
      status: { label: 'Open', color: '#0060D4', bg: '#ECF4FF' }
    },
    {
      id: 'FR-111',
      signal: 'Edited product photo',
      accounts: 'Rohit Jain',
      severity: { label: 'Medium', color: '#6A4A00', bg: '#FFF9E6' },
      raised: '3h ago',
      status: { label: 'Open', color: '#0060D4', bg: '#ECF4FF' }
    },
    {
      id: 'FR-109',
      signal: 'Screener answers copied across accounts',
      accounts: '4 accounts',
      severity: { label: 'Medium', color: '#6A4A00', bg: '#FFF9E6' },
      raised: '1d ago',
      status: { label: 'Investigating', color: '#4E0089', bg: '#F7EDFF' }
    },
    {
      id: 'FR-104',
      signal: 'Researcher asked for Aadhaar in screener',
      accounts: 'Freelance – Priya M.',
      severity: { label: 'Medium', color: '#6A4A00', bg: '#FFF9E6' },
      raised: '2d ago',
      status: { label: 'Open', color: '#0060D4', bg: '#ECF4FF' }
    },
    {
      id: 'FR-098',
      signal: 'Repeated no-shows',
      accounts: 'Karan Gill',
      severity: { label: 'Low', color: '#60606B', bg: '#F2F2F2' },
      raised: '5d ago',
      status: { label: 'Resolved', color: '#007A21', bg: '#DCFFE5' }
    }
  ]);

  const approvalsCount = studiesData.pending.length;
  const verificationCount = verificationItems.length;
  const failedPayoutsCount = failedPayouts.length;
  const openTicketsCount = tickets.filter((t) => t.isOpen).length;
  const openSafetyCount = safetyCases.filter((c) => c.status.label !== 'Resolved').length;

  const approveStudy = (id) => {
    setStudiesData((prev) => {
      const study = prev.pending.find((s) => s.id === id);
      if (!study) return prev;
      return {
        ...prev,
        pending: prev.pending.filter((s) => s.id !== id),
        approved: [study, ...prev.approved]
      };
    });
  };

  const removeVerificationItem = (id) => {
    setVerificationItems((prev) => prev.filter((item) => item.id !== id));
  };

  const retryPayout = (id) => {
    setFailedPayouts((prev) => prev.filter((p) => p.id !== id));
  };

  const resolveTicket = (id) => {
    setTickets((prev) =>
      prev.map((t) => (t.id === id ? { ...t, isOpen: false, status: { label: 'Resolved', color: '#007A21', bg: '#DCFFE5' } } : t))
    );
  };

  const resolveSafetyCase = (id) => {
    setSafetyCases((prev) =>
      prev.map((c) => (c.id === id ? { ...c, status: { label: 'Resolved', color: '#007A21', bg: '#DCFFE5' } } : c))
    );
  };

  return (
    <DataContext.Provider
      value={{
        studiesData,
        setStudiesData,
        approvalsCount,
        approveStudy,
        verificationItems,
        setVerificationItems,
        verificationCount,
        removeVerificationItem,
        failedPayouts,
        setFailedPayouts,
        failedPayoutsCount,
        retryPayout,
        tickets,
        setTickets,
        openTicketsCount,
        resolveTicket,
        safetyCases,
        setSafetyCases,
        openSafetyCount,
        resolveSafetyCase
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
